import { useState } from 'react';

export default function ProductsPage() {
  const [activeFilter, setActiveFilter] = useState('all');

  const heartProducts = [
    { id: 1, name: 'Tình yêu mộng mơ', image: 'https://drive.google.com/thumbnail?id=1Y2GwDD0qMreREvPo3wwGzieIvU_iQU2K&sz=w1000' },
    { id: 2, name: 'Tình yêu vô tận', image: 'https://drive.google.com/thumbnail?id=1XvAc69k5xLMyiP2LZeBOOMh8zHKHBz6v&sz=w1000' },
    { id: 3, name: 'Tình yêu đại dương', image: 'https://drive.google.com/thumbnail?id=1-6IOp8xLtWGAiswuEz2lS2vRI7X4IwYU&sz=w1000' },
    { id: 4, name: 'Làn gió tình yêu', image: 'https://drive.google.com/thumbnail?id=1x_fU0tg9Cye_FzjDCskZO8G2UNtZ4048&sz=w1000' },
    { id: 5, name: 'Tình yêu vĩnh cửu', image: 'https://drive.google.com/thumbnail?id=1U8eSowP55wy_N-bngCTq9qjjSFnm6wC4&sz=w1000' },
    { id: 6, name: 'Tình yêu dịu dàng', image: 'https://drive.google.com/thumbnail?id=1UKxDYhj5AH108BYm5L6ehbg64Qf2JlU1&sz=w1000' },
    { id: 7, name: 'Tình yêu nắng mai', image: 'https://drive.google.com/thumbnail?id=1okTtxNZMhW7an9B1PMOotH7KE8JzmmtO&sz=w1000' },
    { id: 8, name: 'Tình yêu rực rỡ', image: 'https://drive.google.com/thumbnail?id=1qXkdbK_bo0DzIZZnRyz8B0-_lrLgfGc8&sz=w1000' },
    { id: 9, name: 'Nụ hôn tình yêu', image: 'https://drive.google.com/thumbnail?id=1JQtYjbXLdKLQFqbPQz_NWW73SpGqVJCE&sz=w1000' },
    { id: 10, name: 'Ánh sáng tình yêu', image: 'https://drive.google.com/thumbnail?id=1SXA5tJNbFhEBhsbcZz7VWTbwEO8XylOK&sz=w1000' },
    { id: 11, name: 'Tình yêu say đắm', image: 'https://drive.google.com/thumbnail?id=11JppyKVBGNSQcmDMb0uYPbt3htBThV5r&sz=w1000' },
    { id: 12, name: 'Kẹo ngọt tình yêu', image: 'https://drive.google.com/thumbnail?id=17hWR41sLJZYPj42Q9vO-3-Fx24ZfTbin&sz=w1000' },
    { id: 13, name: 'Giấc mơ tình yêu', image: 'https://drive.google.com/thumbnail?id=1oqSRh8V1pARuV-ar4YDyT9_-n-tdzmim&sz=w1000' },
    { id: 14, name: 'Tình yêu ngọt ngào', image: 'https://drive.google.com/thumbnail?id=1mi7I38olp82t8kEVEaKkbhIzUCeAc8KN&sz=w1000' },
    { id: 15, name: 'Tình yêu huyền bí', image: 'https://drive.google.com/thumbnail?id=16MKZt_evEit-BTWy1IhWMjuSHnHRpnMK&sz=w1000' },
    { id: 16, name: 'Tình yêu thuần khiết', image: 'https://drive.google.com/thumbnail?id=1DAKH8s2qF1lE7MXWdiwT3pFzXLTSOfKY&sz=w1000' },
  ];

  const animalProducts = [
    { id: 17, name: 'Blue Hello Kitty', image: 'https://drive.google.com/thumbnail?id=1cwzGB7kyhMuXiB0PvpfNR7zTZNoHQgOx&sz=w1000' },
    { id: 18, name: 'Pink Hello Kitty', image: 'https://drive.google.com/thumbnail?id=14k5_Mcs29mQuuZP1gJIHErjjHIPdpR1a&sz=w1000' },
    { id: 19, name: 'Happy Monkey', image: 'https://static.readdy.ai/image/5a848622a3e6dbb60998be004dc90877/a5a6fc4bd18d0c12995a2549af50791f.png' },
    { id: 20, name: 'Merry Horse', image: 'https://drive.google.com/thumbnail?id=1zJwRoSgPZ4PpK_yERW5A_RZtrdg0llur&sz=w1000' },
    { id: 21, name: 'Lucky Monkey', image: 'https://drive.google.com/thumbnail?id=1xCFv_PN6rKH5LEtBW4gowcHkFfen4Yki&sz=w1000' },
    { id: 22, name: 'Happy Pig', image: 'https://drive.google.com/thumbnail?id=1e8OhPwe62RvP0nMVIsyMwYxTsZlJXE4w&sz=w1000' },
  ];

  const getFilteredProducts = () => {
    if (activeFilter === 'heart') return heartProducts;
    if (activeFilter === 'animal') return animalProducts;
    return [...heartProducts, ...animalProducts];
  };

  const filteredProducts = getFilteredProducts();

  return (
    <main className="pt-20">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <a className="flex items-center gap-3" href="/">
              <img 
                alt="Hearts of Love Logo" 
                className="h-12 w-12 object-contain" 
                src="https://static.readdy.ai/image/d681489af65230a5411b61d45fe6420c/ccdb2c3b737983542d07d1620e150fe2.png"
              />
              <div className="flex flex-col">
                <span className="font-serif font-bold text-xl text-pink-600">Hearts of Love</span>
                <span className="text-xs text-gray-600">Hạt cườm nhỏ - Ước mơ lớn</span>
              </div>
            </a>
            <div className="hidden md:flex items-center gap-8">
              <a className="font-medium text-gray-700 hover:text-pink-600 transition-colors whitespace-nowrap" href="/">Trang chủ</a>
              <a className="font-medium text-gray-700 hover:text-pink-600 transition-colors whitespace-nowrap" href="/about">Câu chuyện</a>
              <a className="font-medium text-pink-600 transition-colors whitespace-nowrap" href="/products">Sản phẩm</a>
            </div>
            <a href="https://zalo.me/0976753302" target="_blank" rel="noopener noreferrer" className="hidden md:block px-6 py-2.5 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer bg-pink-500 text-white hover:bg-pink-600">
              Liên hệ ngay
            </a>
            <button className="md:hidden">
              <i className="ri-menu-line text-2xl text-pink-600"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-b from-pink-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center">
            <div className="inline-block bg-pink-200 text-pink-700 px-5 py-2 rounded-full text-sm font-medium mb-6">
              Sản phẩm thủ công
            </div>
            <h1 className="font-serif font-bold text-6xl lg:text-7xl text-pink-700 mb-6">
              Bộ sưu tập Hearts of Love
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Mỗi sản phẩm được làm hoàn toàn bằng tay bởi nghệ nhân khiếm thị, mang theo câu chuyện và tâm huyết riêng
            </p>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-24 bg-white" data-product-shop>
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {/* Filter Buttons */}
          <div className="flex justify-center gap-3 mb-16">
            <button 
              onClick={() => setActiveFilter('all')}
              className={`px-6 py-2.5 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeFilter === 'all' ? 'bg-pink-500 text-white' : 'bg-pink-100 text-pink-700 hover:bg-pink-200'
              }`}
            >
              Tất cả sản phẩm
            </button>
            <button 
              onClick={() => setActiveFilter('heart')}
              className={`px-6 py-2.5 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeFilter === 'heart' ? 'bg-pink-500 text-white' : 'bg-pink-100 text-pink-700 hover:bg-pink-200'
              }`}
            >
              Móc khóa/ charm Trái tim
            </button>
            <button 
              onClick={() => setActiveFilter('animal')}
              className={`px-6 py-2.5 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeFilter === 'animal' ? 'bg-pink-500 text-white' : 'bg-pink-100 text-pink-700 hover:bg-pink-200'
              }`}
            >
              Móc khóa/ charm Con thú
            </button>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProducts.map((product) => (
              <div key={product.id}>
                <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow group cursor-pointer">
                  <div className="relative h-96 w-full overflow-hidden bg-pink-50">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="font-serif text-xl text-black mb-2">{product.name}</h3>
                    <div className="flex items-baseline gap-2 mb-4">
                      {product.id <= 16 ? (
                        <>
                          <p className="font-sans font-bold text-xl text-pink-600">25.000đ</p>
                          <p className="text-sm text-gray-500">(Từ 20.000đ khi đặt số lượng lớn)</p>
                        </>
                      ) : (
                        <p className="font-sans font-bold text-xl text-pink-600">35.000đ</p>
                      )}
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-600 mb-4">
                      <i className="ri-gift-line"></i>
                      <span>Bao gồm túi organza & thiệp ý nghĩa</span>
                    </div>
                    <a
                      href="https://zalo.me/0976753302"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-pink-600 text-white rounded-full font-medium hover:bg-pink-700 transition-all cursor-pointer whitespace-nowrap"
                    >
                      Đặt hàng ngay
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-24 bg-pink-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <div className="inline-block bg-pink-200 text-pink-700 px-5 py-2 rounded-full text-sm font-medium mb-6">
              Bảng giá
            </div>
            <h2 className="font-sans font-bold text-5xl lg:text-6xl text-pink-700 mb-6">
              Giá ưu đãi theo số lượng
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Càng đặt nhiều, giá càng tốt. Phù hợp cho mọi nhu cầu từ cá nhân đến doanh nghiệp
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Pricing Card 1 */}
            <div>
              <div className="bg-white rounded-3xl p-8 h-full flex flex-col shadow-sm">
                <div className="text-center mb-6">
                  <h3 className="font-sans font-bold text-2xl text-pink-700 mb-2">Mua lẻ</h3>
                  <p className="text-gray-500 text-sm">1 - 99 bộ</p>
                </div>

                <div className="text-center mb-8">
                  <div className="flex items-baseline justify-center gap-1">
                    <span className="font-sans font-bold text-5xl text-pink-600">25.000đ</span>
                    <span className="text-gray-500 text-lg">/bộ</span>
                  </div>
                </div>

                <ul className="space-y-4 mb-8 flex-1">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm">Móc khóa/ charm trái tim hạt cườm</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm">Túi organza cao cấp</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm">Thiệp ý nghĩa</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm">Giao hàng toàn quốc</span>
                  </li>
                </ul>

                <a
                  href="https://zalo.me/0976753302"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full flex items-center justify-center gap-2 px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap bg-pink-100 text-pink-700 hover:bg-pink-200"
                >
                  Đặt hàng ngay
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            {/* Pricing Card 2 - Popular */}
            <div>
              <div className="bg-white rounded-3xl p-8 h-full flex flex-col ring-2 ring-pink-500 shadow-xl scale-105">
                <div className="bg-pink-500 text-white text-sm font-medium px-4 py-2 rounded-full text-center mb-4">
                  Phổ biến nhất
                </div>

                <div className="text-center mb-6">
                  <h3 className="font-sans font-bold text-2xl text-pink-700 mb-2">Đặt số lượng vừa</h3>
                  <p className="text-gray-500 text-sm">100 - 199 bộ</p>
                </div>

                <div className="text-center mb-8">
                  <div className="flex items-baseline justify-center gap-1">
                    <span className="font-sans font-bold text-5xl text-pink-600">22.000đ</span>
                    <span className="text-gray-500 text-lg">/bộ</span>
                  </div>
                </div>

                <ul className="space-y-4 mb-8 flex-1">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm">Tất cả ưu đãi gói Mua lẻ</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm">Giảm giá 12%</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm">Tư vấn chọn màu phù hợp</span>
                  </li>
                </ul>

                <a
                  href="https://zalo.me/0976753302"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full flex items-center justify-center gap-2 px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap bg-pink-500 text-white hover:bg-pink-600"
                >
                  Đặt hàng ngay
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            {/* Pricing Card 3 */}
            <div>
              <div className="bg-white rounded-3xl p-8 h-full flex flex-col shadow-sm">
                <div className="text-center mb-6">
                  <h3 className="font-sans font-bold text-2xl text-pink-700 mb-2">Đặt số lượng lớn</h3>
                  <p className="text-gray-500 text-sm">200+ bộ</p>
                </div>

                <div className="text-center mb-8">
                  <div className="flex items-baseline justify-center gap-1">
                    <span className="font-sans font-bold text-5xl text-pink-600">20.000đ</span>
                    <span className="text-gray-500 text-lg">/bộ</span>
                  </div>
                </div>

                <ul className="space-y-4 mb-8 flex-1">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm">Tất cả ưu đãi gói trước</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm">Giảm giá 20%</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm">Ưu tiên sản xuất</span>
                  </li>
                </ul>

                <a
                  href="https://zalo.me/0976753302"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full flex items-center justify-center gap-2 px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap bg-pink-100 text-pink-700 hover:bg-pink-200"
                >
                  Đặt hàng ngay
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Animal Products Info */}
          <div className="mt-16 bg-white rounded-3xl p-8 lg:p-12">
            <div className="text-center mb-8">
              <h3 className="font-sans font-bold text-3xl text-pink-700 mb-4">
                Móc khóa/ charm Con thú
              </h3>
              <p className="text-gray-600 text-base leading-relaxed max-w-3xl mx-auto">
                Các mẫu móc khóa/ charm hình con thú (Mèo, Khỉ, Ngựa, Heo) được làm hoàn toàn thủ công với độ chi tiết cao. Mỗi sản phẩm có thể mất vài ngày đến một tuần để hoàn thành.
              </p>
            </div>

            <div className="flex items-baseline justify-center gap-2 mb-8">
              <span className="font-sans font-bold text-4xl text-pink-600">35.000đ</span>
              <span className="text-gray-500">/con</span>
            </div>

            <ul className="space-y-3 mb-8 max-w-2xl mx-auto">
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                <span className="text-gray-700 text-sm">Bao gồm sản phẩm + túi organza + thiệp</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                <span className="text-gray-700 text-sm">Làm thủ công hoàn toàn, chi tiết cao</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                <span className="text-gray-700 text-sm">Thời gian hoàn thành: 1-3 ngày/sản phẩm</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0"></i>
                <span className="text-gray-700 text-sm">Có thể đặt hàng theo màu yêu cầu của khách</span>
              </li>
            </ul>

            <div className="text-center">
              <a
                href="https://zalo.me/0976753302"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-pink-600 text-white rounded-full font-medium hover:bg-pink-700 transition-all cursor-pointer whitespace-nowrap"
              >
                Đặt hàng ngay
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-pink-500 text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
            <div className="md:col-span-5">
              <h2 className="font-serif font-bold text-5xl mb-2">Hearts of Love</h2>
              <p className="text-pink-100/80 text-base mb-6">Hạt cườm nhỏ - Ước mơ lớn</p>
              <p className="text-pink-100/70 text-sm leading-relaxed mb-8 w-11/12">
                Mỗi sản phẩm thủ công từ Hearts of Love là một câu chuyện về nghị lực, kiên trì và ước mơ hòa nhập của những người khiếm thị tại Mái Ấm Khiếm Thị Nhật Hồng.
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a href="mailto:xuanthaomtgtd@gmail.com" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-mail-line text-lg"></i>
                </a>
                <a href="tel:0785976111" className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-phone-line text-lg"></i>
                </a>
              </div>
            </div>
            <div className="md:col-span-4">
              <div className="space-y-8">
                <div>
                  <h3 className="text-pink-100/60 text-xs uppercase tracking-wider mb-3 font-medium">ĐỊA CHỈ</h3>
                  <p className="text-white text-sm leading-relaxed">Mái Ấm Khiếm Thị Nhật Hồng<br />TP. Hồ Chí Minh, Việt Nam</p>
                </div>
                <div>
                  <h3 className="text-pink-100/60 text-xs uppercase tracking-wider mb-3 font-medium">ĐIỆN THOẠI / ZALO</h3>
                  <p className="text-white text-sm">0785976111 - 0976753302</p>
                </div>
                <div>
                  <h3 className="text-pink-100/60 text-xs uppercase tracking-wider mb-3 font-medium">EMAIL</h3>
                  <p className="text-white text-sm">xuanthaomtgtd@gmail.com</p>
                </div>
              </div>
            </div>
            <div className="md:col-span-3">
              <div className="w-full md:w-9/12 ml-auto">
                <img 
                  alt="Nghệ nhân khiếm thị đang làm việc" 
                  className="w-full h-80 object-cover object-center rounded-xl" 
                  src="https://drive.google.com/thumbnail?id=1ZDXXA1O8fEOn3H6lWiaekm2-WldZelAH&sz=w2000"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-white/20">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-pink-100/60 text-xs">© 2025 Hearts of Love. All rights reserved.</p>
              <div className="flex gap-6">
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-pink-100/60 text-xs hover:text-white transition-colors cursor-pointer">
                  Powered by Readdy
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </main>
  );
}